import React, { useState, useEffect, useCallback } from 'react';
import './ManageDrivers.css';

const API_URL = process.env.REACT_APP_API_URL;

const ManageDrivers = () => {
  const [drivers, setDrivers] = useState([]);
  const [inviteEmail, setInviteEmail] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const fetchDrivers = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/api/drivers?search=${searchTerm}&page=${currentPage}`);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setDrivers(data.drivers || []);
      setTotalPages(data.totalPages || 0);
    } catch (error) {
      console.error('Failed to fetch drivers:', error);
      setDrivers([]);
    }
  }, [searchTerm, currentPage]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchDrivers();
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [fetchDrivers]);

  const handleInviteDriver = async (e) => {
    e.preventDefault();
    if (inviteEmail.trim() === '') return;

    try {
      const response = await fetch(`${API_URL}/api/send-invitation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: inviteEmail }),
      });

      if (response.ok) {
        alert(`Invitation envoyée à ${inviteEmail}`);
        setInviteEmail('');
      } else {
        const errorText = await response.text();
        alert(`Erreur lors de l'envoi de l'invitation: ${errorText}`);
      }
    } catch (error) {
      console.error('Failed to send invitation:', error);
      alert('Une erreur réseau est survenue.');
    }
  };

  const handleDeleteDriver = async (driverId) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce chauffeur ?')) {
      try {
        await fetch(`${API_URL}/api/drivers/${driverId}`, { method: 'DELETE' });
        fetchDrivers();
      } catch (error) {
        console.error('Failed to delete driver:', error);
      }
    }
  };

  const handleToggleStatus = async (driverId, currentStatus) => {
    try {
      await fetch(`${API_URL}/api/drivers/${driverId}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ isActive: !currentStatus })
      });
      fetchDrivers();
    } catch (error) {
      console.error('Failed to toggle status:', error);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  
  return (
    <div className="manage-drivers">
      <h2>Gestion des chauffeurs</h2>
      
      <form onSubmit={handleInviteDriver} className="add-driver-form">
        <input 
          type="email" 
          placeholder="E-mail du chauffeur à inviter" 
          value={inviteEmail}
          onChange={(e) => setInviteEmail(e.target.value)}
          required
        />
        <button type="submit">Envoyer l'invitation</button>
      </form>
      
      <div className="search-container">
        <input
          type="text"
          placeholder="Rechercher par nom ou e-mail..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      <ul>
        {drivers.length > 0 ? drivers.map(driver => (
          <li key={driver.id}>
            <span>{driver.name || 'N/A'} ({driver.email})</span>
            <div className="driver-actions">
              <label className="toggle-switch">
                <input 
                  type="checkbox" 
                  checked={driver.isActive}
                  onChange={() => handleToggleStatus(driver.id, driver.isActive)} 
                />
                <span className="slider"></span>
              </label>
              <button onClick={() => handleDeleteDriver(driver.id)} className="delete-btn">Supprimer</button>
            </div>
          </li>
        )) : (
          <li>Aucun chauffeur trouvé.</li>
        )}
      </ul>

      {totalPages > 1 && (
        <div className="pagination">
          <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            Précédent
          </button>
          <span>Page {currentPage} sur {totalPages}</span>
          <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            Suivant
          </button>
        </div>
      )}
    </div>
  );
};

export default ManageDrivers;
